import { createFileRoute } from '@tanstack/react-router'
import { PermissionRouteGuard } from '@/hooks/usePermissions'
import { AccountPage } from '@/pages/AccountPage'

export const Route = createFileRoute('/_authenticated/accounts/$affiliationId')({
  component: AccountRoute,
})

/** Admin only (#1360): the data behind it refuses anyone else as well (#1454). */
function AccountRoute() {
  const { affiliationId } = Route.useParams()
  return (
    <PermissionRouteGuard resource="settings" action="manage">
      <AccountPage key={affiliationId} affiliationId={affiliationId} />
    </PermissionRouteGuard>
  )
}
